import { IExtraResponseObj } from './interfaces';

/**
 * The extra as offered for the given room. The extras of all rooms are merged into one list, but each room's extra
 * is priced for that room's guests and signed with that room's rate, so the price and signature of the room
 * replace the merged ones. The cart shows and the reservation sends what this returns. An extra without a price for
 * the room (a ticket, which has one price for all rooms) is returned as it is.
 */
export function priceExtraForRoom<T extends IExtraResponseObj>(extra: T, roomIndex: number): T {
  const roomPrice = extra.roomPrices?.[roomIndex];

  if (roomPrice?.unitPriceForStayWithTaxes === undefined) {
    return extra;
  }

  return {
    ...extra,
    totalPriceForStayWithTaxes: roomPrice.unitPriceForStayWithTaxes,
    unitPriceForStayWithTaxes: roomPrice.unitPriceForStayWithTaxes,
    signature: roomPrice.signature ?? null
  };
}
